// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Request from '../../../../api/Request';
import { observable } from 'mobx';
import SubmitButton from '../../../Util/SubmitButton/SubmitButton';

@inject('userStore', 'messageStore')
@observer class ChangeUsername extends Component<any, any> {

	@observable username: string = '';

	@observable loading: boolean = false;

	maxLengthUsername: number = 30;

	constructor(props: any) {
		super(props);

		this.changeUsername = this.changeUsername.bind(this);
		this.onChangeUsername = this.onChangeUsername.bind(this);
	}

	changeUsername() {
		if (this.loading) {
			return;
		}

		if (this.username !== '') {
			this.loading = true;
			Request.put('/me/change/username', {
				username: this.username
			}, {}).then((response) => {
				this.loading = false;

				if (!response.status) {
					this.props.userStore.refreshUser(response.user, response.token);
					this.props.messageStore.setMessage('success', 'successfully changed username to ' + response.user.username, 2000)
				}
			});
		} else {
			this.props.messageStore.setMessage('error', 'username field cannot be empty');
		}
	}

	onChangeUsername(e: any) {
		if (e.target.value.length < this.maxLengthUsername) {
			this.username = e.target.value
		}
	}

	render() {
		return (
			<div className="profile-edit-change-username">
				<h2>change username.</h2>
				<form onSubmit={(e: any) => {e.preventDefault(); this.changeUsername();}}>
					<label>
						new username:
						<input type="text" name="username" value={this.username} onChange={this.onChangeUsername} />
					</label>
					<SubmitButton text="change" loading={this.loading} />
				</form>
			</div>
		)
	}
}

export default ChangeUsername;

